<template>
     <div class="main-container">
          <!-- <div class="mall-member-switch">
               <span>企业订房</span>
               <el-switch v-model="switchForm.open" :active-value="1" :inactive-value="2" active-color="#13ce66"
                    @change="handleOpen"></el-switch>
               <span style="font-size: 12px;color: #666666">合作企业预定订房功能|关闭</span>
          </div> -->
          <el-form inline :model="searchForm" ref="searchForm" @keydown.enter.native="handleSearch" label-width="80px"
               size="small">
               <el-form-item label="企业名称" prop="name">
                    <el-input v-model="searchForm.name" placeholder="请输入企业名称" clearable style="width: 210px"></el-input>
               </el-form-item>
               <el-form-item label="手机号" prop="phone">
                    <el-input v-model="searchForm.phone" placeholder="请输入手机号" clearable style="width: 210px"></el-input>
               </el-form-item>
               <el-form-item label="联系人" prop="contact">
                    <el-input v-model="searchForm.contact" placeholder="请输入联系人" clearable style="width: 210px"></el-input>
               </el-form-item>
               <el-form-item label="结算类型" prop="type">
                    <el-select v-model="searchForm.type" placeholder="结算类型" style="width: 120px">
                         <el-option label="信用额度" :value="0"></el-option>
                         <el-option label="月结" :value="1"></el-option>
                    </el-select>
               </el-form-item>
               <el-form-item>
                    <el-button icon="el-icon-search" type="primary" @click="handleSearch" size="small">搜索</el-button>
                    <el-button @click="handleReset" size="small">重置</el-button>
               </el-form-item>
          </el-form>

          <el-button icon="el-icon-plus" type="primary" size="small" @click="handleAdd" style="width: 100px;">新增</el-button>
          <el-button icon="el-icon-plus" type="primary" size="small" @click="handleShow"
               style="width: 100px;">授权二维码</el-button>

          <el-table border size="small" style="width:100%;margin-top:10px;" :data="tableData" v-loading="isLoading"
               element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0, 0, 0, 0.8)">
               <el-table-column type="index" label="#" align="center"></el-table-column>
               <el-table-column prop="contact" label="联系人" align="center" width="150"></el-table-column>
               <el-table-column prop="phone" label="手机号" align="center" width="150"></el-table-column>
               <el-table-column prop="name" label="企业名称" align="center" width="220"></el-table-column>
               <el-table-column prop="discount" label="企业折扣" align="center" width="150"></el-table-column>
               <el-table-column prop="typeDesc" label="结算类型" align="center" width="150">
                    <template slot-scope="{row}">
                         <el-tag size="mini">{{ row.typeDesc }}</el-tag>
                    </template>
               </el-table-column>
               <el-table-column prop="amount" label="可用余额(元)" align="center" width="150"></el-table-column>
               <el-table-column prop="totalCredit" label="信用额度(元)" align="center" width="150"></el-table-column>
               <el-table-column prop="monthDept" label="月结欠额(元)" align="center" width="150"></el-table-column>
               <el-table-column prop="usedAmount" label="已用额度(元)" align="center" width="150"></el-table-column>
               <el-table-column prop="createTime" label="创建时间" align="center" width="170"></el-table-column>
               <el-table-column label="操作" fixed="right" width="220">
                    <template slot-scope="{row}">
                         <el-button size="mini" type="text" @click="handleShowDetail(row)">账单明细</el-button>
                         <el-button size="mini" type="text" @click="handleEditCrdite(row)">额度管理</el-button>
                         <el-button size="mini" type="text" @click="handlebindHotel(row)">绑定酒店</el-button>
                         <el-button size="mini" type="text" style="color:red" @click="handleDel(row)">解绑授信</el-button>
                    </template>
               </el-table-column>
          </el-table>

          <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage"
               style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]"
               :page-size="searchForm.pagesIZE" layout="total, sizes, prev, pager, next, jumper"
               :total="total"></el-pagination>

          <el-dialog title="授信二维码" width="320px" :visible.sync="modalVisible" append-to-body destroy-on-close
               :close-on-press-escape="false" :close-on-click-modal="false" @close="modalVisible = false">
               <div class="warm-tips">
                    <i class="el-icon-info"></i>
                    <div>
                         <span>企业用户通过扫描授权二维码，完成微信与手机号进行绑定，完成绑定后可该依信可直接使用企业钱包与充值服务，企业订房灵活结算。</span>
                    </div>
               </div>
               <div class="img">
                    <img :src="imgUrl" alt="" style="max-height: 150px;max-width: 150px;border-radius: 50%;" />
               </div>
               <div slot="footer">
                    <el-button type="text" @click="modalVisible = false">确认</el-button>
               </div>
          </el-dialog>
          <AddEditComponent :isShow="isShow" @close="isShow = false" @confirm="refreshData" />
          <QuotaManageComponent :isDetail="isDetail" :propsData="propsData" @close="refreshData" />
          <!-- 授权酒店 -->
          <AuthHotelComponentut :isBind="isBind" :httpConfig="httpConfig" :propsData="{ creditWalletId: creditWalletId }" :tableProp="{ nickname: 'contact' }" @close="isBind = false" />
     </div>
</template>

<script>

import AddEditComponent from "./addEditComponent/index.vue";
import QuotaManageComponent from "./quotaManageComponent/index.vue"
import AuthHotelComponentut from "@/components/authHotelComponent/index.vue";

export default {
     components: {
          AddEditComponent,
          QuotaManageComponent,
          AuthHotelComponentut
     },
     computed: {
          pagePermission() {
               return this.$store.state.pagePermission;
          },

     },
     data() {

          return {
               isBind: false,
               imgUrl: '',
               switchForm: {
                    open: 1
               },
               httpConfig: {
                    getHotel: "/walletHotel/getPage",//get获取已绑定的酒店列表
                    selectHotel: "/api/hotel/page",//get获取要绑定的酒店列表
                    bindHotel: "/walletHotel/bindHotel",//postRequest绑定
                    unbindHotel: "/walletHotel/unBindHotel"
               },
               searchForm: {
                    name: "",
                    phone: '',
                    contact: '',
                    type: '',
                    pageNumber: 1,
                    pageSize: 10
               },
               tableData: [],
               total: 0,
               isLoading: false,
               isShow: false,
               typeList: [],
               propsData: {},
               creditWalletId: '',
               modalVisible: false,
               isDetail: false
          }
     },

     methods: {
          handlebindHotel(row) {
               this.creditWalletId = row.id;
               this.$nextTick(() => {
                    this.isBind = true;
               })
          },
          handleShow() {
               this.exportRequest(`/api/hotel/getEnterCode?path=/pages/companyBind/index`)
                    .then(res => {
                         let reader = new FileReader();
                         reader.readAsText(res.data, "utf-8")
                         reader.onload = e => {
                              let data = e.target.result;
                              if (!data.includes("msg")) {
                                   let blob = new Blob([res.data], { type: 'image/png' });
                                   let reader = new FileReader();
                                   reader.readAsDataURL(blob);

                                   reader.onload = e => {
                                        this.imgUrl = e.target.result;
                                        this.modalVisible = true
                                   }
                              } else {
                                   // this.$message.warning(JSON.parse(data).msg);
                              }

                         }
                    })
          },
          handleShowDetail(item) {
               this.$router.push(`/index/enterpriseRecord?phone=${item.phone}`);
          },
          handleEditCrdite(item) {
               this.propsData = item;
               this.isDetail = true;
          },
          handleAdd() {
               this.isShow = true;
          },
          refreshData() {
               this.isShow = false;
               this.isDetail = false;
               this.getTableData();
          },
          handleDel(item) {
               this.$confirm(`您确认要解除该企业的授信?`, "解除授信", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
               }).then(() => {
                    this.deleteRequest(`/enterCredit/deleteCredit?id=${item.id}`)
                         .then(res => {
                              let data = res.data;
                              if (data.code == 200) {
                                   this.$message.success("解除成功");
                                   this.getTableData();
                              }
                         })
               })
          },
          getTableData() {
               this.isLoading = true;
               this.getRequest("/enterCredit/getPage", this.searchForm)
                    .then(res => {
                         this.isLoading = false;
                         let data = res.data;
                         if (data.code == 200) {
                              this.tableData = data.data.records;
                              this.total = data.data.total;
                         }
                    }).catch(() => {
                         this.isLoading = false;
                    })
          },

          handleSearch() {
               this.searchForm.pageNumber = 1;
               this.getTableData();
          },

          handleReset() {
               this.searchForm = {
                    name: "",
                    phone: '',
                    contact: '',
                    type: '',
                    pageNumber: 1,
                    pageSize: 10
               };
               this.getTableData();
          },

          handleChangePage(page) {
               this.searchForm.pageNumber = page;
               this.getTableData();
          },

          handleChangeSize(size) {
               this.searchForm.pageNumber = 1;
               this.searchForm.pageSize = size;
               this.getTableData();
          },
          handleOpen() {

          },
          getAllType() {
               this.getRequest("/enterCreditChange/getAllTransactType")
                    .then(res => {
                         let data = res.data;
                         if (data.code == 200) {
                              this.typeList = data.data;
                         }
                    })
          }
     },

     created() {
          this.getTableData();
          this.getAllType();
     },
}
</script>

<style lang="less">@import "./index.less";</style>